<template>
  <div class="analytics-period-picker">
    <button
      v-for="period in periods"
      :key="period.value"
      class="period-button"
      :class="{ active: modelValue === period.value }"
      @click="selectPeriod(period.value)"
    >
      {{ period.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AnalyticsPeriodPicker',
  props: {
    modelValue: {
      type: String,
      default: 'monthly'
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      periods: [
        { value: 'daily', label: 'D' },
        { value: 'weekly', label: 'W' },
        { value: 'monthly', label: 'M' },
        { value: 'quarterly', label: 'Q' },
        { value: 'yearly', label: 'Y' }
      ]
    };
  },
  methods: {
    selectPeriod(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style scoped>
.analytics-period-picker {
  display: flex;
  height: 31px;
}

.period-button {
  flex: 1;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-right: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 31px;
}

.period-button:first-child {
  border-left: 1px solid #e5e7eb;
}

.period-button:last-child {
  border-right: 1px solid #e5e7eb;
}

.period-button:hover {
  background: #f3f4f6;
  z-index: 1;
}

.period-button.active {
  background: #4338ca;
  border-color: #4338ca;
  color: #fff;
  z-index: 2;
}
</style>
